<script>
import {BPopover, BLink} from 'bootstrap-vue'

export default {
    components: {BPopover, BLink},
    props: {
        elements: {
            default() {
                return [];
            }
        },
        visibleCount: {
            default: 1
        }
    },
    data() {
        return {
            popoverShow: false,
            id: (Math.random() + 1).toString(36).substring(7)
        }
    },
    watch: {
        elements() {
            this.$forceUpdate();
        }
    }
}
</script>

<template>
    <div>
        <div v-for="(element, index) in elements">
            <div v-if="(index + 1) <= visibleCount">
                <slot v-bind:element="element" v-bind:index="index">
                    {{ element }}
                </slot>
            </div>
        </div>
        <slot name="link" v-bind:id="'more' + id" v-if="elements.length > visibleCount">
            <div><b-link :id="'more-' + id">More</b-link></div>
        </slot>
        <b-popover
            :target="'more-' + id"
            triggers="hover"
            placement="auto"
            ref="popover"
        >
            <slot name="list" v-bind:elements="elements">
                <div v-for="(element, index) in elements">
                    <slot name="item" v-bind:element="element" v-bind:index="index">
                        {{ element }}
                    </slot>
                </div>
            </slot>
        </b-popover>
    </div>
</template>
